module.exports = __webpack_public_path__ + "img/checkmark-badge.507ba69d.svg";